import { render } from "./star.vue?vue&type=template&id=02afc088"
import script from "./star.vue?vue&type=script&lang=js"
export * from "./star.vue?vue&type=script&lang=js"

import exportComponent from "/var/deploy/production_one/web_head/releases/20260331201443/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__